import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { LoaderComponent } from '../../servicios/loader/loader.component';
import { SeleccionService } from '../../servicios/seleccion.service';
import { ToolsService } from '../../recursos/tools.service';
import { AlertifyService } from 'src/app/recursos/alertify.service';
import { recursosCompartido } from 'src/app/recursos/cosumoGeneral.service';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-estudio-socio-ec-lista',
  templateUrl: './estudio-socio-ec-lista.component.html',
  styleUrls: ['./estudio-socio-ec-lista.component.css']
})
export class EstudioSocioEcListaComponent implements OnInit {

  public mr: NgbModalRef;
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptionsGen: DataTables.Settings = {};
  dtOptionsEsp: DataTables.Settings = {};
  public dtTriggerGen: Subject<any>;
  public dtTriggerEsp: Subject<any>;

  public nombreBeca: string = ""; public vecPeriodo = []; public vecEstudio = []; public periodoBuscar: string = '';
  public rutaCarga: SafeResourceUrl | undefined; public enlaceCarga: string = ''; private tokenDrive: any;
  public vecObservacion = [];

  constructor(private modalService: NgbModal, private tools: ToolsService, private srvSelect: SeleccionService, private alerti: AlertifyService,
    private srvGeneral: recursosCompartido, private sanitizer: DomSanitizer, private cargando: LoaderComponent) { }

  async ngOnInit() {
    this.nombreBeca = localStorage.getItem('modNom');

    this.dtTriggerEsp = new Subject<any>();
    this.dtOptionsEsp[0] = this.tools.OpcionesTabla(10);
    this.tokenDrive = await this.srvGeneral.getTokenLocal();
    this.instanciaVecObserva('', '', '', '', '', '', 0);
    this.cargarPeriodos();
  }
  //FUNCION QUE CARGA TODAS LAS FACULTADES DE LA INSTITUCION
  async cargarPeriodos() {
    this.vecPeriodo = []; this.periodoBuscar = '';
    //OBTENER LOS PERIODO ACADÉMICOS DE LA MASTER
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionCarreras(3, 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      this.periodoBuscar = res.carrera[0]['strCodigo'];
      for (let i in res.carrera) {
        this.vecPeriodo.push({
          codigo: res.carrera[i]['strCodigo'], descripcion: res.carrera[i]['strDescripcion'], inicio: res.carrera[i]['dtFechaInic'], fin: res.carrera[i]['dtFechaFin']
        });
      }
    }
  }
  //FUNCION PARA ABRIR EL MODAL MUESTRA LOS PERIODOS ACADÉMICOS
  modalVerPeriodos(nameMod) {
    if (localStorage.getItem('modUser') == 'true')
      this.mr = this.modalService.open(nameMod);
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //VER EL LISTADO DE ESTUDIOS SOCIO ECONÓMICOS
  async verEstudiosSocioEconomicos() {
    this.vecEstudio = [];
    var table3 = $('#tblEspecifico').DataTable({
      destroy: true
    });
    table3.destroy();

    const resEstudio = await new Promise<any>(resolve =>
      this.srvSelect.gestionSocioEconomico(8, this.periodoBuscar, 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resEstudio.resultado)
      this.vecEstudio = resEstudio.socioEconomico;
    else
      this.alerti.error('No se encontraron registros');console.log(this.vecEstudio)
    this.cerrarModal();
    this.dtTriggerEsp.next();
  }
  //MODAL PARA VER EL DOCUMENTO ENVIADO POR LA ANALISTA
  verArchivoCarga(nombModal, dataEstudio, opc) {
    if (localStorage.getItem('modUser') == 'true') {
      this.mr = this.modalService.open(nombModal);
      this.verObservacionEstudioSocioEc(dataEstudio, opc);
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //FUNCION QUE CARGA EL PDF Y OBSERVACIONES DEL ESTUDIO SOCIO ECONOMICO
  async verObservacionEstudioSocioEc(estudioSocioEc, op) {
    const resEstudio = await new Promise<any>(resolve =>
      this.srvSelect.gestionSocioEconomico(7, estudioSocioEc.intIdRegistro, 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resEstudio.resultado) {
      this.instanciaVecObserva(resEstudio.socioEconomico[0]['intIdObserva'], resEstudio.socioEconomico[0]['strDetalle'], resEstudio.socioEconomico[0]['strRuta'],
        resEstudio.socioEconomico[0]['intRegistro'], resEstudio.socioEconomico[0]['dtFecha'], resEstudio.socioEconomico[0]['strRegistro'], resEstudio.socioEconomico[0]['intEstado']);
      if (op == 1) {
        this.rutaCarga = await this.srvGeneral.obtenerArchivoPDF(this.tokenDrive, resEstudio.socioEconomico[0]['strRuta']);
        this.enlaceCarga = await this.srvGeneral.obtenerRutaPDF(this.tokenDrive, resEstudio.socioEconomico[0]['strRuta']);
      }
      else {
        console.log(resEstudio.socioEconomico);
        console.log(this.vecObservacion)
      }
    }
  }
  //INSTANCIAR EL VECTOR DE LAS OBSERVACIONES
  instanciaVecObserva(dato1, dato2, dato3, dato4, dato5, dato6, dato7) {
    this.vecObservacion = [];
    this.vecObservacion.push({ intIdObserva: dato1, strDetalle: dato2, strRuta: dato3, intRegistro: dato4, dtFecha: dato5, strRegistro: dato6, intEstado: dato7 })
  }
  cerrarModal() {
    this.mr.close();
  }
}
